import compose from 'recompose/compose';
import renderNothing from 'recompose/renderNothing';

import branch from '@aveneo/frontmoon-utils/lib/hocs/branch';

import { connect } from 'react-redux';
import { selectMenus,
    selectActiveMenuId,
    selectMultipleMenus,
    enableAutoUpdateMenu,
    enableAutoUpdateMenuCategory,
    setActiveCategory } from 'src/modules/Menu';

const mapDispatchToProps = {
    setActiveCategory,
    enableAutoUpdateMenu,
    enableAutoUpdateMenuCategory
};

const mapStateToProps = (state) => ({
    menus: selectMenus(state),
    activeMenuId: selectActiveMenuId(state),
    multipleMenus: selectMultipleMenus(state)
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    branch(
        ({ menus }) => menus.length === 1,
        renderNothing
    )
);
